// removed by extract-text-webpack-plugin
module.exports = {"Container":"VaccChild__Container__2QUQs","Vaccination":"VaccChild__Vaccination__5R0Vz","UniqueSpan":"VaccChild__UniqueSpan__3u35l","Btn":"VaccChild__Btn__x7vu4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChildController/ViewChild/VaccChild/VaccChild.css
// module id = 108
// module chunks = 0